// client/helper/runInsertNode.ts
function runInsertNode(identifier, getOptions) {
  return (state, view) => {
    const { tr } = view.state;
    const { attrs, content } = getOptions?.(state) ?? {};
    const nodeType = state.schema.nodes[identifier];
    if (!nodeType)
      throw new Error("Node type " + identifier + " not found.");
    const selectionFrom = view.state.selection.from;
    const resolvedPos = view.state.doc.resolve(selectionFrom);
    const currentNode = resolvedPos.parent;
    if (currentNode && currentNode.type === state.schema.nodes.paragraph && currentNode.textContent === "") {
      tr.replaceSelectionWith(nodeType.create(attrs, content));
    } else {
      tr.insert(selectionFrom, nodeType.create(attrs, content));
    }
    view.dispatch(tr);
  };
}
export {
  runInsertNode
};
